import * as React from 'react';
import './popup.css';
type Props = {
  title: string;
};
const Popup: React.FunctionComponent<Props> = ({ title, children }) => (
  <div className="popup">
    <h2 className="title">{title}</h2>
    <hr />
    <div className="content">{children}</div>
  </div>
);

export default Popup;
